const { formatText } = require('core/i18n').i18n;

const text = () => {
    return {
        HOME_INSURANCE: formatText('insuranceLanding-homeInsurance'),
        MOBILE_INSURANCE: formatText('insuranceLanding-mobileInsurance'),
        DESCRIPTION_MORTGAGE_INSURANCE: formatText('insuranceLanding-descriptionInsurance'),
        PAYMENT: {
            ANNUAL: formatText('insuranceLanding-annualPayment'),
            BIANNUAL: formatText('insuranceLanding-biannualPayment'),
            QUARTERLY: formatText('insuranceLanding-quarterlyPayment')
        }
    };
};

module.exports = {
    text
};
